import {
  COUPON_ROUTES,
  couponListResponseSchema,
  couponResponseSchema,
  couponValidateResponseSchema,
  type Coupon,
  type CouponInput,
  type CouponListQuery,
  type CouponPublic,
  type Currency,
} from "@nh/shared";
import { authFetch } from "@/shared/api/session";

/**
 * Los cupones: el panel los crea y apaga; el checkout valida un código
 * antes de pagar. `baseUrl: ""` porque las rutas del contrato ya traen
 * el prefijo `/api`.
 */
const NO_PREFIX = { baseUrl: "" } as const;

export interface CouponPage {
  items: Coupon[];
  total: number;
  page: number;
  perPage: number;
}

/** Filtros y paginación EN LA URL: el servidor devuelve solo la página. */
export function listCoupons(query: CouponListQuery): Promise<CouponPage> {
  const params = new URLSearchParams();
  params.set("page", String(query.page));
  params.set("perPage", String(query.perPage));
  if (query.query) params.set("query", query.query);
  if (query.status) params.set("status", query.status);
  return authFetch(
    `${COUPON_ROUTES.adminList}?${params.toString()}`,
    couponListResponseSchema,
    NO_PREFIX,
  );
}

export async function createCoupon(input: CouponInput): Promise<Coupon> {
  const data = await authFetch(COUPON_ROUTES.adminCreate, couponResponseSchema, {
    ...NO_PREFIX,
    method: "POST",
    body: input,
  });
  return data.coupon;
}

export async function setCouponActive(id: string, active: boolean): Promise<Coupon> {
  const data = await authFetch(COUPON_ROUTES.adminOne(id), couponResponseSchema, {
    ...NO_PREFIX,
    method: "PATCH",
    body: { active },
  });
  return data.coupon;
}

/**
 * "¿Este código vale para mi pedido?" — lo llama el CHECKOUT para
 * estimar el descuento en pantalla. El cobro real lo recalcula el
 * servidor al crear la orden, con la misma aritmética compartida.
 */
export async function validateCoupon(
  code: string,
  currency: Currency,
): Promise<CouponPublic> {
  const data = await authFetch(COUPON_ROUTES.validate, couponValidateResponseSchema, {
    ...NO_PREFIX,
    method: "POST",
    body: { code, currency },
  });
  return data.coupon;
}
